import FnrButtonPopper from "UI/FnrButtonPopper";
import FnrIconButton from "UI/FnrIconButton";
import FnrScaleIt from "UI/FnrScaleIt";

import { useFnrPencilEditInputContext } from "../FnrPencilEditInput";

const MoreMenu = () => {
  const {
    iconButtonProps,
    onEdit,
    onCancel,
    moreMenu,
    moreMenuHasPopper,
    setMoreMenuOpen,
    moreMenuPopperRef,
  } = useFnrPencilEditInputContext();
  if (!moreMenu) return null;
  if (moreMenuHasPopper)
    return (
      <FnrScaleIt>
        <FnrButtonPopper
          Button={FnrIconButton}
          buttonProps={{
            icon: "fa-ellipsis-h fas",
            type: "button",
            "aria-label": "More Menu",
            ...iconButtonProps,
          }}
          onClose={() => {
            onCancel();
            setMoreMenuOpen(false);
          }}
          onOpen={() => {
            onEdit();
            setMoreMenuOpen(true);
          }}
          color="white"
          content={moreMenu}
          ref={moreMenuPopperRef}
        />
      </FnrScaleIt>
    );

  // no popper. Just display it.
  return moreMenu;
};

export default MoreMenu;
